// After an idea of: https://willtaylor.blog/client-side-routing-in-vanilla-js/
import routes from '~routes/routes';
import AsyncLoad from '~utilities/async-load';

class Router {

    constructor() {
        const script = document.querySelector('[enable-routes]');
        if(script) {
            this.enableRoutes = script.getAttribute('enable-routes') === 'true';
        }

        this.asyncLoad = new AsyncLoad();
        if(this.enableRoutes) this.loadRoute();
    }

    get getRoute() {
        return this.route;
    }

    matchedRoute(path) {
        const matchedRoute = this.matchUrlToRoute(this.getPathSegments(path));
        if(matchedRoute && this.enableRoutes) return matchedRoute;
        return false;
    }

    loadRoute() {
        this.route = this.matchedRoute(window.location.pathname);
        if(!this.route.template) this.route = this.matchedRoute('/404');
        window.route = this.route;
        if(this.route && this.route.template) this.asyncLoad.loadPage(this.route.template, this.asyncLoad.onLoad);
    }
  
    matchUrlToRoute(urlSegments) {
        const routeParams = {};

        // Try and match the URL to a route.
        const matchedRoute = routes.find(route => {

            // We assume that the route path always starts with a slash, and so 
            // the first item in the segments array  will always be an empty
            // string. Slice the array at index 1 to ignore this empty string.
            const routePathSegments = route.path.split('/').slice(1);

            // If there are different numbers of segments, then the route does not match the URL.
            if (routePathSegments.length !== urlSegments.length) {
                return false;
            }

            // If each segment in the url matches the corresponding segment in the route path, 
            // or the route path segment starts with a ':' then the route is matched.
            const match = routePathSegments.every((routePathSegment, i) => {
                return routePathSegment === urlSegments[i] || routePathSegment[0] === ':';
            });

            // If the route matches the URL, pull out any params from the URL.
            if (match) {
            routePathSegments.forEach((segment, i) => {
                if (segment[0] === ':') {
                    const propName = segment.slice(1);
                    routeParams[propName] = decodeURIComponent(urlSegments[i]);
                }
            });
            }
            return match;
        });
        return { ...matchedRoute, params: routeParams };
    }

    getPathSegments(path) {
        // Figure out the path segments for the route which should load initially.
        const pathnameSplit = path.split('/');
        return pathnameSplit.length > 1 ? pathnameSplit.slice(1) : '';
    }
}
export default new Router();